import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import BalanceSheetSkeleton from '@components/Group/Portfolio/Skeleton/BalanceSheetSkeleton';
import ProfitAndFinanceSkeleton from '@components/Group/Portfolio/Skeleton/ProfitAndFinanceSkeleton';

const ProfitAndFinance = lazy(
  () => import('@components/Group/Portfolio/ProfitAndFinance')
);
const BalanceSheet = lazy(
  () => import('@components/Group/Portfolio/BalanceSheet')
);

/** 조합 관리 > 상세 > 포트폴리오 상세 > 손익재무 */
const Finance = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<ProfitAndFinanceSkeleton />}>
          <ProfitAndFinance />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<BalanceSheetSkeleton />}>
          <BalanceSheet />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Finance;
